import { render } from "./FormLoader.vue?vue&type=template&id=c83f9d6a&ts=true"
import script from "./FormLoader.vue?vue&type=script&lang=ts"
export * from "./FormLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__